<template lang="pug">
.section.content.has-text-centered
  div.margin-top-40
    img(src="png/welcome-client.png")
  template(v-if="isUnverified")
    div.margin-top-40
      div Thank you for signing up.
      div To verify your account, please click the
      div link we sent to {{ email }}.
      div Once verified, you can search for trainers!
    div.margin-top-40
      .field
        .control
          .buttons.is-centered
            button.button.is-primary(v-on:click="resendVerificationEmail") Resend verification email
  template(v-else)
    div.margin-top-40
      div Thank you for verifying your email.
    div.margin-top-40
      .field
        .control
          .buttons.is-centered
            a.button.is-primary(href="/") Search for trainers
</template>

<script>
import Constants from '@/constants'

import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  mixins: [
    ApiMixin
  ],
  computed: {
    email () {
      return this.apiClient.email
    },
    isOperator () {
      return Constants.OPERATOR !== 3
    },
    isUnverified () {
      return this.apiClient.status === Constants.STATUS_UNVERIFIED
    },
    title () {
      return Constants.TITLE
    }
  },
  methods: {
    async resendVerificationEmail () {
      await this.apiResendVerificationEmail()
    }
  }
}
</script>
